export default __webpack_public_path__ + "static/media/ezzam-artworkinfo2.479001f5.png";